import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSafeNextPath } from '@/utils/redirect';
const PublicRoute = ({ isLoggedIn, children }) => {
    const location = useLocation();
    // An MCP client sent the user to /login to authorize a connection (see
    // mcp_server/oauth/browser.py::authorize on the backend). Bouncing an
    // already-signed-in recruiter straight to /dashboard here would skip the
    // login form entirely and leave nothing to hand back to the MCP client, so
    // this always shows the form -- a fresh sign-in -- regardless of any
    // existing session.
    const isMcpConnection = new URLSearchParams(location.search).has('mcp_auth');
    if (isLoggedIn && !isMcpConnection) {
        // Honor a `?next=` target (e.g. the report link that bounced through login)
        // so an already-authenticated user lands where they were headed; otherwise
        // send them to the dashboard.
        const next = getSafeNextPath(location.search);
        return _jsx(Navigate, { to: next || '/dashboard', replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
export default PublicRoute;
